import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { formatDateTime } from "@repo/utils/date";

type Props = {
  id: string;
  date: Date | string;
  representative: string;
  login: string;
  logout: string;
  numberOfVehicles: number;
};

function CreateDeliveryDealTable({
  id,
  date,
  representative,
  login,
  logout,
  numberOfVehicles,
}: Props) {
  return (
    <Table
      aria-label="simple table"
      sx={{
        mb: 4,
        "& tbody tr td": {
          borderBottom: "none",
        },
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Numéro de contrat :</TableCell>
          <TableCell>Date :</TableCell>
          <TableCell>Mandataire :</TableCell>
          <TableCell>Prise en charge :</TableCell>
          <TableCell>Livraison :</TableCell>
          <TableCell>Nombre de véhicules :</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{id}</TableCell>
          <TableCell>{date ? formatDateTime(date) : <i>Error</i>}</TableCell>
          <TableCell>{representative ?? "Arval"}</TableCell>
          <TableCell>{login}</TableCell>
          <TableCell>{logout}</TableCell>
          <TableCell>{numberOfVehicles}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default CreateDeliveryDealTable;
